import React from "react";
import {
  createMandatoryServiceCode,
  updateMandatoryServiceCode,
  getMandatoryServiceCodeDetail,
} from "../../helpers/backend_helper";
import CodeDetail from "./CodeDetail";

const MandatoryServiceDetail = (props) => (
  <CodeDetail
    {...props}
    codeLabel="Must Cover Code"
    getCodeDetail={getMandatoryServiceCodeDetail}
    createCode={createMandatoryServiceCode}
    updateCode={updateMandatoryServiceCode}
  />
);

export default MandatoryServiceDetail;
